import { apiGateway } from '@va/api-client';
import { storageItems } from '@va/standalone/shared/constants';
import { addTokensToLocalStorage } from '@va/standalone/shared/helpers';
import { LocalStorage } from '@va/util/helpers';

export function addCredentialsToLocalStorage(data: { userId?: string; token: string; refreshToken: string }) {
  apiGateway.setAuthToken(data.token);

  LocalStorage.setItem(storageItems.userId, data.userId);
  addTokensToLocalStorage({ token: data.token, refreshToken: data.refreshToken });
}
